import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import PreOrderForm from './PreOrderForm';
import mapBy from '../../lib/mapBy';
import filterObject from '../../lib/filterObject';

function PreOrderFormContainer(props) {
  return (
    <PreOrderForm
      {...props}
      onSubmit={async ({ tickets }) => {
        const {
          mutate,
          event,
          ticketTypes,
          subtotalValue,
          coupon,
          totalValue,
          nextRegisterExtensionStep,
          setPreOrder,
        } = props;

        const ticketTypesById = mapBy(ticketTypes, 'id');
        const filteredTickets = filterObject(tickets);

        try {
          const {
            data: { createPreOrder: preOrder },
          } = await mutate({
            mutation: createPreOrder,
            variables: {
              input: {
                eventId: event.id,
                tickets: filteredTickets,
                subtotalValue,
                couponCode: coupon && coupon.code,
                totalValue,
              },
            },
          });

          const preOrderTickets = [];
          Object.keys(preOrder.tickets).forEach(ticketTypeId => {
            for (var i = 0; i < preOrder.tickets[ticketTypeId]; i++) {
              preOrderTickets.push(ticketTypesById[ticketTypeId]);
            }
          });

          setPreOrder(preOrder, preOrderTickets);
          nextRegisterExtensionStep();
        } catch (e) {
          console.error(e);
        }
      }}
    />
  );
}

PreOrderFormContainer.propTypes = {
  mutate: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  ticketTypes: PropTypes.array,
  subtotalValue: PropTypes.number.isRequired,
  coupon: PropTypes.object,
  totalValue: PropTypes.number.isRequired,
  nextRegisterExtensionStep: PropTypes.func.isRequired,
  setPreOrder: PropTypes.func.isRequired,
};

PreOrderFormContainer.defaultProps = {
  coupon: undefined,
  ticketTypes: null,
};

const createPreOrder = gql`
  mutation createPreOrder($input: PreOrderInput!) {
    createPreOrder(input: $input) {
      id
      tickets
      subtotalValue
      totalValue
      createdAt
      expireAt
    }
  }
`;

export default graphql(createPreOrder)(PreOrderFormContainer);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/PreOrderForm/PreOrderFormContainer.js